import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const STATES_SKIPTOWN_OPERATES_IN_OR_NEAR = ['NC', 'GA', 'CO', 'MO', 'TN', 'TX', 'SC']

const useConstants = () => {
	const constants = useSelector((state) => state.general.constants.constants)
	const requiredVaccines = useSelector((state) => state.general.constants.required_vaccines)

	const {
		trainingTags = [],
		trainingSkills = [],
		trainingCourseIdentifiers = [],
		trainingSizes = [],
		states = [],
		buildingTypes = [],
		appointmentStatuses = [],
		trainingAttendanceStatuses = [],
		tags = {}
	} = constants || {}

	const statesSkiptownOperatesInOrNear = useMemo(() => {
		return states.filter((state) => STATES_SKIPTOWN_OPERATES_IN_OR_NEAR.includes(state.abbreviation))
	}, [states])

	return {
		trainingSkills,
		trainingTags,
		trainingCourseIdentifiers,
		trainingSizes,
		trainingAttendanceStatuses,
		states,
		statesSkiptownOperatesInOrNear,
		buildingTypes,
		appointmentStatuses,
		tags,
		requiredVaccines
	}
}

export default useConstants
